import React, { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

type Props = {
  align?: 'vertical' | 'horizontal';
};

export const MoreIcon = memo(({ align = 'vertical' }: Props) => (
  <IconWrapper>
    {align === 'vertical' ? (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fill="currentColor"
          // eslint-disable-next-line max-len
          d="M12 18.1a.674.674 0 0 1-.494-.206.674.674 0 0 1-.206-.494c0-.192.068-.357.206-.494A.674.674 0 0 1 12 16.7c.193 0 .357.069.494.206a.674.674 0 0 1 .206.494.674.674 0 0 1-.206.494.674.674 0 0 1-.494.206Zm0-5.4a.674.674 0 0 1-.494-.206A.674.674 0 0 1 11.3 12c0-.193.068-.357.206-.494A.674.674 0 0 1 12 11.3c.193 0 .357.069.494.206A.674.674 0 0 1 12.7 12a.674.674 0 0 1-.206.494.674.674 0 0 1-.494.206Zm0-5.4a.674.674 0 0 1-.494-.206.674.674 0 0 1-.206-.494c0-.192.068-.357.206-.494A.674.674 0 0 1 12 5.9c.193 0 .357.069.494.206a.674.674 0 0 1 .206.494.674.674 0 0 1-.206.494A.674.674 0 0 1 12 7.3Z"
        />
      </svg>
    ) : (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fill="currentColor"
          // eslint-disable-next-line max-len
          d="M6.6 12.7a.674.674 0 0 1-.494-.206A.674.674 0 0 1 5.9 12c0-.193.069-.357.206-.494A.674.674 0 0 1 6.6 11.3c.193 0 .357.069.494.206A.674.674 0 0 1 7.3 12a.674.674 0 0 1-.206.494.674.674 0 0 1-.494.206Zm5.4 0a.674.674 0 0 1-.494-.206A.674.674 0 0 1 11.3 12c0-.193.069-.357.206-.494A.674.674 0 0 1 12 11.3c.193 0 .357.069.494.206A.674.674 0 0 1 12.7 12a.674.674 0 0 1-.206.494.674.674 0 0 1-.494.206Zm5.4 0a.674.674 0 0 1-.494-.206A.674.674 0 0 1 16.7 12c0-.193.069-.357.206-.494a.674.674 0 0 1 .494-.206c.193 0 .357.069.494.206A.674.674 0 0 1 18.1 12a.674.674 0 0 1-.206.494.674.674 0 0 1-.494.206Z"
        />
      </svg>
    )}
  </IconWrapper>
));
